import * as types from './types'
import { IPaginatedRequest } from '@cbgms/api/request'
import {
  GETPaymentMethodResponse,
  GetPaymentMethodsResponse,
  POSTPaymentMethodBody,
  POSTPaymentMethodResponse,
  PUTPaymentMethodBody,
  PUTPaymentMethodResponse
} from '@cbgms/api/modules/paymentmethods'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const loadPaymentMethods = (params: IPaginatedRequest) => ({
  type: [types.LOAD_PAYMENT_METHODS, types.LOAD_PAYMENT_METHODS_SUCCESS, types.LOAD_PAYMENT_METHODS_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: '/modules/payment-methods',
      params
    }
  }
})

export const getPaymentMethod = (paymentMethodUUID: string) =>
  AsyncAction<GETPaymentMethodResponse>({
    type: [types.LOAD_PAYMENT_METHOD, types.LOAD_PAYMENT_METHOD_SUCCESS, types.LOAD_PAYMENT_METHOD_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/payment-methods/${paymentMethodUUID}`
      }
    }
  })

export const createPaymentMethod = (body: POSTPaymentMethodBody) =>
  AsyncAction<POSTPaymentMethodResponse>({
    type: [types.CREATE_PAYMENT_METHOD, types.CREATE_PAYMENT_METHOD_SUCCESS, types.CREATE_PAYMENT_METHOD_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/payment-methods',
        data: body
      }
    }
  })

export const updatePaymentMethod = (paymentMethodUUID: string, body: PUTPaymentMethodBody) =>
  AsyncAction<PUTPaymentMethodResponse>({
    type: [types.UPDATE_PAYMENT_METHOD, types.UPDATE_PAYMENT_METHOD_SUCCESS, types.UPDATE_PAYMENT_METHOD_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/payment-methods/${paymentMethodUUID}`,
        data: body
      }
    }
  })

export const deletePaymentMethod = (paymentMethodUUID: string, dryRun: boolean) => ({
  type: [types.DELETE_PAYMENT_METHOD, types.DELETE_PAYMENT_METHOD_SUCCESS, types.DELETE_PAYMENT_METHOD_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'DELETE',
      url: `/modules/payment-methods/${paymentMethodUUID}`,
      params: {
        DryRun: dryRun
      }
    }
  }
})

export const loadAllPaymentMethods = () =>
  AsyncAction<GetPaymentMethodsResponse>({
    type: [types.LOAD_ALL_PAYMENT_METHODS, types.LOAD_ALL_PAYMENT_METHODS_SUCCESS, types.LOAD_ALL_PAYMENT_METHODS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/payment-methods',
        params: {
          PerPage: 99999,
          Fields: 'Name,Description,UUID,IsEnabled'
        }
      }
    }
  })
